/**
 * Homepage Scroll Effects — Tiffany-style
 * - Hero is fixed in viewport, content scrolls over it
 * - Subtle hero fade on scroll
 * - Section scroll-reveal animations
 * 
 * Only enabled when "Immersive Hero Component (homepage)" flag is ON
 * (detected via .header--transparent-menu class on header)
 */

(function () {
  'use strict';

  function isImmersiveHeroEnabled() {
    // Check if header has the transparent menu class (indicates Immersive Hero flag is ON)
    var header = document.querySelector('header-component.header--transparent-menu');
    return !!header;
  }

  function initFixedHero() {
    // Only enable parallax effect if Immersive Hero flag is ON
    if (!isImmersiveHeroEnabled()) {
      console.log('[ScrollEffects] Immersive Hero disabled, skipping parallax effect');
      return true; // Return true to stop retrying
    }

    // Target the <builder-component> custom element directly
    var builderEl = document.querySelector('builder-component[name="homepage-hero-carousel"]');
    if (!builderEl) {
      console.log('[ScrollEffects] builder-component not found');
      return;
    }

    console.log('[ScrollEffects] Hero found:', builderEl.tagName, builderEl.offsetHeight);

    // Get the hero's natural height
    var heroHeight = builderEl.offsetHeight;
    if (heroHeight < 50) {
      // Builder might not have rendered yet, retry
      console.log('[ScrollEffects] Hero height too small (' + heroHeight + '), retrying...');
      return false;
    }

    // The hero offsetHeight includes the area behind the fixed header, but the spacer sits below the header in normal flow, so subtract the actual header height to avoid an extra gap.
    function getHeaderOffset() {
      return window.innerWidth < 750 ? 48 : 40;
    }

    // Insert a spacer to preserve layout flow
    var spacer = document.createElement('div');
    spacer.className = 'hero-parallax-spacer';
    spacer.style.height = (heroHeight - getHeaderOffset()) + 'px';
    builderEl.parentNode.insertBefore(spacer, builderEl.nextSibling);

    // Make hero fixed
    builderEl.classList.add('hero-fixed');

    // Update spacer height on resize
    window.addEventListener('resize', function () {
      builderEl.classList.remove('hero-fixed');
      spacer.style.height = (builderEl.offsetHeight - getHeaderOffset()) + 'px';
      builderEl.classList.add('hero-fixed');
    });

    // Opacity animation removed — animating opacity on a fixed GPU-promoted layer
    // causes subpixel compositing artifacts (blur) on scroll. Content scrolls over
    // the hero naturally via the z-index:1 content wrapper.
    builderEl.style.opacity = '1';

    console.log('[ScrollEffects] Fixed hero initialized, height=' + heroHeight);
    return true;
  }

  // ─── Section Scroll Reveal ───
  function initScrollReveal() {
    var sections = document.querySelectorAll(
      '.builder-component[data-name="homepage"] .builder-block'
    );
    if (!sections.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('scroll-reveal--visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    sections.forEach(function (el) {
      el.classList.add('scroll-reveal');
      observer.observe(el);
    });
  }

  // ─── Init with retry ───
  function init() {
    var attempts = 0;
    var maxAttempts = 30;

    var interval = setInterval(function () {
      attempts++;
      var result = initFixedHero();
      if (result === true) {
        clearInterval(interval);
        setTimeout(initScrollReveal, 1000);
      } else if (attempts >= maxAttempts) {
        clearInterval(interval);
        console.log('[ScrollEffects] Gave up after ' + maxAttempts + ' attempts');
      }
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
